module.exports = __webpack_public_path__ + "img/公司简介.d533989d.jpg";